// DO NOT EDIT -- generated from fs/services/playback/highlight.proto

import * as protobuf from '../../../google/protobuf';

export interface Note {
  id: string;
  created: protobuf.timestamp | null;
  creator: string;
  indvId: string;
  userId: string;
  sessionId: string;
  pageId: string;
  pageStart: protobuf.timestamp | null;
  when: protobuf.int64;
  absTime: protobuf.timestamp | null;
  text: string;
  link: string;
  shareLink: string;
  /** TODO(kyle): this field doesn't appear to actually be used by the client - consider removing */
  sessionOrClipTime: protobuf.timestamp | null;
  isClip: boolean;
  userEmail: string;
  userDisplayName: string;
  actions: Action[];
  devTools: DevToolsMode;
  sentNotes: { [key: string]: string };
}

/**
 * Highlight is a legacy concept where numerous "Notes" of different types could be associated with a single Highlight
 * object. In practice, this was never implemented and there is a 1-to-1 mapping between "Highlight" objects and session
 * replay Notes. We're in the process of migrating this to a single "Session Note" concept, but currently the FSTA "Notes"
 * page uses "Highlight" objects, and session replay displays "Note" objects. Until we've unified these concepts, we still
 * use the term "Highlight" in some places.
 */
export interface Highlight {
  id: string;
  text: string;
  lastModified: protobuf.timestamp | null;
  creator: string;
  created: protobuf.timestamp | null;
  image: string;
  noteId: string;
  sentIntegrations: { [key: string]: string };
  actions: Action[];
  devToolsMode: DevToolsMode;
}

export enum DevToolsMode {
  DEV_TOOLS_MODE_NONE = 0,
  DEV_TOOLS_MODE_CONSOLE = 1,
  DEV_TOOLS_MODE_NETWORK = 2
}

/** An action to take on a Highlight */
export interface Action {
  label: string;
  css: string;
  link: string;
}
